import styled from 'styled-components';
import View from '@sdk/components/primitives/View';

type WrapperProps = {
  hasError?: boolean;
};

export const Wrapper = styled(View)<WrapperProps>`
  min-width: 300px;
  border: 1px solid;
  border-color: ${({ hasError, theme }) =>
    hasError ? theme.colors.danger : theme.colors.separatorOnWhite};
  background-color: ${({ theme }): string => theme.colors.white};
  border-radius: 2px;
  width: 100%;
  position: relative;
`;
